import classes from "./ErrorMsg.module.css";

export function ErrorMsg({ msg }) {
  return <div className={`fadeInTranslate ${classes.msg}`}>{msg}</div>;
}
